
import React from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
// reactstrap components
import { Container, Row } from "reactstrap";
// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";

import routes from "routes.js";
import { useTranslation } from "react-i18next";
import PreFooterBanner from "components/Footers/PreFooterBanner";

const Admin = (props) => {
  const { t } = useTranslation();
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === props.layoutPath) {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props.location.pathname.indexOf(routes[i].layout + routes[i].path) !==
        -1
      ) {
        return t(routes[i].translation);
      }
    }
    return "Brand";
  };

  return (
    <>
      <Sidebar
        {...props}
        routes={routes.filter((rt) => rt.layout === props.layoutPath && rt.showInSidebar)}
        logo={{
          innerLink: props.layoutPath + "/index",
          imgSrc: require("../assets/img/brand/logo.png").default,
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props.location.pathname)}
        />
        <div className="admin-header-divider pt-5 pt-xl-6 mb-3"></div>
        <div style={{ minHeight: "50vh" }}>
          <Switch>
            {getRoutes(routes)}
            {props.isSessionChecked && <Redirect from="*" to="/" />}
          </Switch>
        </div>

        <Container fluid className="pt-4">
          {props.layoutPath === "/public" && <PreFooterBanner />}
          <AdminFooter layout={props.layoutPath} />
        </Container>
      </div>
    </>
  );
};

export default Admin;
